export enum MovingType {
    SECTION = 'section',
    DOCUMENT = 'document',
    NOT_FOUND = 'not found'
}